import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import Error from "../components/error";
import css from "./Sub.module.css"
import Loading from "../components/Loading";

const SubscriptionPage = () => {
    const navigate = useNavigate();
    const [subscription, setSubscription] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [progress_traffic, setProgressTraffic] = useState("0");
    const [progress_traffic_bs, setProgressTrafficBS] = useState("0");
    const [is_copied, setIsCopied] = useState(false);

    const params = new URLSearchParams(window.location.search);
    const email = params.get("email");
    const subid = params.get("subid");

    document.title = "Подписка | SecureNet"

    const particles = Array.from({length: 30}, (_, i) => (
        <div className={css.particle} key={i}
             style={{left: Math.random() * 100 + "%", animationDelay: Math.random() * 15 + "s", animationDuration: (Math.random() * 10 + 10) + "s"}}>
        </div>
    ));


    const CopySub = async () => {
        const url = window.location.href;
        await navigator.clipboard.writeText(url);
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 1000);
    }

    useEffect(() => {
        // Если нет параметров – сразу ошибка
        if (!email || !subid) {
            const email_localStorage = localStorage.getItem("email");
            const subid_localStorage = localStorage.getItem("subid");
            if (!email_localStorage || !subid_localStorage) {
                setError("Отсутствуют параметры запроса. Проверьте ссылку.");
                setLoading(false);
                return;
            }
            params.append("email", email_localStorage);
            params.append("subid", subid_localStorage);
            window.location.replace("https://bezopas.net/sub?" + params.toString());
        }

        const fetchSubscription = async () => {
            try {
                const result = await loadSubscription(email, subid);
                if (typeof result === 'string') {
                    // Это ошибка
                    if (result === 'Not found') {
                        setError("Подписка не найдена. Возможно вы перешли по неактуальной ссылке.");
                    } else if (result === 'Bad Request') {
                        setError("Произошла техническая ошибка при формировании запроса к API. Пожалуйста, сообщите это в поддержку.");
                    } else if (result === 'Server Error') {
                        setError("Сервер API не отвечает. Сообщите в нашу поддержку.");
                    } else {
                        setError("Неизвестная ошибка.");
                    }
                } else {
                    if (result.expiry_time === 0) {
                        result.expiry_time = "никогда"
                    } else {
                        const date = new Date(result.expiry_time);
                        result.expiry_time = date.toLocaleString();
                    }
                    if(result.used_traffic >= 1073741824) {
                        result.used_traffic = (result.used_traffic / 1073741824).toFixed(2);
                        result.used_traffic = `${result.used_traffic} ГБ`;
                    } else {
                        result.used_traffic = (result.used_traffic / 1048576).toFixed(2);
                        result.used_traffic = `${result.used_traffic} МБ`;
                    }
                    if(result.total_gb !== 0) {
                        result.total_gb = result.total_gb / 1073741824;
                        result.total_gb = `${result.total_gb} ГБ`;
                    } else {
                        result.total_gb = "ထ";
                    }

                    localStorage.setItem("email", email)
                    localStorage.setItem("subid", subid)
                    sessionStorage.setItem("email", email);
                    sessionStorage.setItem("subid", subid);

                    setSubscription({
                        id: result.id,
                        email: result.email,
                        enable: result.enable,
                        used_traffic: result.used_traffic,
                        total_gb: result.total_gb,
                        expiry_time: result.expiry_time
                    });

                    setTimeout(() => {
                        setProgressTraffic("100%")
                        setProgressTrafficBS("0%")
                    }, 5);
                }
            } catch (err) {
                setError("Ошибка при загрузке данных. Попробуйте позже.");
            } finally {
                setLoading(false);
            }
        };

        fetchSubscription();
    }, [email, subid]); // зависимость от параметров

    // Отображение ошибки, если есть
    if (error) {
        return (
           <Error title={"Ошибка"} text={error} />
        );
    }

    // Пока загрузка
    if (loading) {
        return (
            <Loading title={"title"} text={"text"} />
        )
    }

    const isCopiedSVG = (<svg id="copyIcon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                          stroke-linecap="round" stroke-linejoin="round">
        <rect x="9" y="9" width="13" height="13" rx="2" ry="2"/>
        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
    </svg>)

    const copySvg = (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style={{width:"13px", height: "13px"}}><polyline points="20 6 9 17 4 12"/></svg>)

    return (
        <>
            <div className={css.bgGrid}></div>
            <div className={`${css.bgGlow} ${css.bgGlow1}`}></div>
            <div className={`${css.bgGlow} ${css.bgGlow2}`}></div>
            <div className={css.particles} id="particles">
                {particles}
            </div>

            <div className={css.wrap}>
                <div className={css.card}>
                    <div className={css.top}>
                        <div className={css.logo}>
                            <div className={css.logoIco}>
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                                     stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                                </svg>
                            </div>
                            Secure Internet
                        </div>
                        <div className={`${css.pill}` + (subscription.enable? "" : ` ${css.inactive}`)}><span className={`${css.d}` + (subscription.enable? "" : ` ${css.inactive}`)}></span>{subscription.enable? "Активна" : "Неактивна"}</div>
                    </div>

                    <div className={css.data}>
                        <div className={css.item}>
                            <div className={css.itemK}>
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                                    <circle cx="12" cy="7" r="4"/>
                                </svg>
                                ID
                            </div>
                            <div className={css.itemV}>{subscription.id}</div>
                        </div>
                        <div className={css.item}>
                            <div className={css.itemK}>
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <circle cx="12" cy="12" r="10"/>
                                    <polyline points="12 6 12 12 16 14"/>
                                </svg>
                                Истекает
                            </div>
                            <div className={css.itemV}>{subscription.expiry_time}</div>
                        </div>
                        <div className={`${css.item} ${css.wide}`}>
                            <div className={css.itemK}>
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                                    <polyline points="22,6 12,13 2,6"/>
                                </svg>
                                Email
                            </div>
                            <div className={css.itemV}>{subscription.email}</div>
                        </div>
                    </div>

                    <div className={css.traffic}>
                        <div className={css.trafficTop}>
                            <span className={css.k}>Трафик</span>
                            <span className={css.v}>{subscription.used_traffic + " / " + subscription.total_gb}</span>
                        </div>
                        <div className={css.bar}>
                            <div className={css.barFill} style={{width: progress_traffic}}></div>
                        </div>
                    </div>

                    <div className={css.traffic}>
                        <div className={css.trafficTop}>
                            <span className={css.k}>Трафик БС</span>
                            <span className={css.v}>- / -</span>
                        </div>
                        <div className={css.bar}>
                            <div className={css.barFill} style={{width: progress_traffic_bs}}></div>
                        </div>
                    </div>

                    <div className={css.actions}>
                        <button className={`${css.btnCopy}` + (is_copied? ` ${css.copied}` : "")} type="button" onClick={CopySub}>
                            {is_copied? copySvg : isCopiedSVG}

                            <span id="copyText">
                                {is_copied? "Ссылка скопирована" : "Скопировать ссылку на подписку"}
                            </span>
                        </button>

                        <button className={`${css.btn} ${css.btnPrimary}`} onClick={() => navigate("/connect")}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                 stroke-linejoin="round">
                                <path d="M5 12h14M12 5l7 7-7 7"/>
                            </svg>
                            Подключиться
                        </button>

                        <div className={css.row2}>
                            <a href="https://t.me/" target="_blank" rel="noopener" className={`${css.btn} ${css.btnGhost}`}>
                                <svg viewBox="0 0 24 24" fill="currentColor">
                                    <path
                                        d="M9.78 18.65l.28-4.23 7.68-6.92c.34-.31-.07-.46-.52-.19L7.74 13.3 3.64 12c-.88-.25-.89-.86.2-1.3l15.97-6.16c.73-.33 1.43.18 1.15 1.3l-2.72 12.81c-.19.91-.74 1.13-1.5.71L12.6 16.3l-1.99 1.93c-.23.23-.42.42-.83.42z"/>
                                </svg>
                                Telegram
                            </a>
                            <a href="https://t.me/" target={"_blank"} rel={"noopener"} className={`${css.btn} ${css.btnGhost}`}>
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                     stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M3 18v-6a9 9 0 0 1 18 0v6"/>
                                    <path d="M21 19a2 2 0 0 1-2 2h-1v-6h3v4zM3 19a2 2 0 0 0 2 2h1v-6H3v4z"/>
                                </svg>
                                Техподдержка
                            </a>
                        </div>

                        <button className={`${css.btn} ${css.btnDonate}`} onClick={() => navigate("/donate")}>
                            <span className={css.shine}></span>
                            <span className={css.heart}>
                              <svg viewBox="0 0 24 24" fill="currentColor" style={{width:15,height:15}}>
                                <path
                                    d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
                              </svg>
                            </span>
                            Поддержать разработчика
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

async function loadSubscription(email, subid) {
    try {
        const base_url = "https://api.bezopas.net/subscription?";
        const params = new URLSearchParams();
        params.append("email", email);
        params.append("subid", subid);
        const full_url = base_url + params.toString();

        const response = await fetch(full_url, {method: "GET"});
        if (response.status === 404) return "Not found";
        if (response.status === 400) return "Bad Request";
        if (!response.ok) return "Server Error";
        return response.json();
    } catch {
        return "Server Error";
    }
}

export default SubscriptionPage;